import React from 'react';
import { useNavigate } from 'react-router-dom';

const UnauthorizedBox = ({
  title = 'Unauthorized',
  message = 'This feature is only available to users with an active subscription.',
  upgradeMessage = 'Upgrade your plan to unlock this feature.',
  featureName = 'this feature',
  showUpgrade = true,
  backToDashboard = false,
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
      <div className="elevated-card border border-red-500/30 rounded-2xl p-8 max-w-md w-full text-center shadow-xl">
        <h2 className="text-2xl font-bold text-[var(--color-danger)] mb-4">{title}</h2>
        <p className="text-[var(--color-text-secondary)] mb-2">{message}</p>
        {upgradeMessage ? (
          <p className="text-[var(--color-text-muted)] text-sm mb-6">{upgradeMessage}</p>
        ) : (
          <div className="mb-6" />
        )}
        {backToDashboard ? (
          <button
            type="button"
            onClick={() => navigate('/dashboard')}
            className="brand-gradient-btn px-6 py-2 rounded-lg font-semibold"
          >
            Back to Dashboard
          </button>
        ) : showUpgrade ? (
          <button
            type="button"
            onClick={() => navigate('/subscriptions')}
            className="brand-gradient-btn px-6 py-2 rounded-lg font-semibold"
          >
            Upgrade Plan
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default UnauthorizedBox;
